import { SUPPORTED_INTEGRATION_BANKS } from "@/constant";
import { BankInfo } from "@/types";

export const getIntegrationBankFromName = (
  bankName: string
): BankInfo | null => {
  const bank = SUPPORTED_INTEGRATION_BANKS.find(
    (item) => item.name === bankName
  );
  if (!bank) return null;
  return {
    ...bank,
    logo: bank.logo ? require(`@/assets/images/${bank.logo}`) : null,
  };
};
